import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { translate } from 'containers/MundialViews/utils/mundialUtils';
import moment from 'moment'
//------------------------------------------------------------------------------
import { CalendarTitle } from '../CalendarTitle';
import { CalendarRow } from '../CalendarRow';
import './style.scss';

export const CalendarTable = ({ jornada, matchDates, matches, translations }) => {
  const getMatches = useCallback(
    () => {
      return matches.filter(
        match =>
          match.dateAndTimeInfo.startDateLocal === moment(matchDates.timeFrom).format("YYYY-MM-DD"),
      );
    },
    [jornada, matches],
  );

  if (!jornada || getMatches().length === 0) return null;

  return (
    <div className="calendar">
      <CalendarTitle
        jornada={jornada}
        dates={matchDates}
        translations={translations}
      />
      <div className="calendar__table">
        <div className="calendar__table__container">
          <div className="calendar__table__container__header">
            <span>{translate('calendar_result_hour_label', translations)}</span>
            <span>
              {translate('calendar_result_teams_label', translations)}
            </span>
          </div>
          <div className="calendar__table__container__registers">
            {getMatches().map(match => (
              <CalendarRow
                key={match.id}
                match={match}
                matchDates={matchDates}
                translations={translations}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
